<template>
    <section id="singup" class="fill-height">
        <v-container
            style="height: inehit"
            class="fill-height px-7 px-md-5 justify-center"
        >
            <v-row justify="space-around" align="center">
                <v-col
                    cols="12"
                    sm="8"
                    md="5"
                    class="text-center"
                    style="transition: all 0.3s ease-out"
                >
                    <v-img
                        :src="require('../../assets/brand/logo1.png')"
                        alt="PBXBerry brand"
                        :width="signupWithEmail ? '30vh' : '45vh'"
                        class="mx-auto"
                        contain
                        style="transition: all 0.3s ease-out"
                    ></v-img>
                    <!-- <h1 class="mt-7 mt-md-12 headline">Bienvenido</h1> -->
                    <p class="mt-8 mb-6">
                        Crea una cuenta
                    </p>

                    <v-row v-show="signupWithEmail === false">
                        <v-col cols="12">
                            <v-btn
                                rounded
                                dark
                                block
                                x-large
                                color="primary"
                                @click="signupWithEmail = true"
                            >
                                <v-icon class="mr-3" left>mdi-email</v-icon>
                                Registrarse con email
                            </v-btn>
                        </v-col>

                        <!-- <v-col cols="12">
                            <v-btn
                                rounded
                                outlined
                                block
                                x-large
                                color="primary"
                            >
                                <v-icon class="mr-3" left
                                    >$vuetify.icons.google</v-icon
                                >
                                Registrarse con Google
                            </v-btn>
                        </v-col> -->
                    </v-row>

                    <v-expand-transition>
                        <div v-show="signupWithEmail">
                            <ValidationObserver ref="obs" v-slot="{ passes }">
                                <v-form @submit.prevent="passes(signup)">
                                    <ValidationProvider
                                        name="nombre"
                                        rules="required"
                                        v-slot="{ errors }"
                                    >
                                        <v-text-field
                                            required
                                            filled
                                            rounded
                                            label="Nombre"
                                            name="firstname"
                                            type="text"
                                            color="secondary"
                                            v-model="userData.firstname"
                                            :error-messages="errors"
                                        ></v-text-field>
                                    </ValidationProvider>

                                    <ValidationProvider
                                        name="apellido"
                                        rules="required"
                                        v-slot="{ errors }"
                                    >
                                        <v-text-field
                                            required
                                            filled
                                            rounded
                                            label="Apellido"
                                            name="lastname"
                                            type="text"
                                            color="secondary"
                                            v-model="userData.lastname"
                                            :error-messages="errors"
                                        ></v-text-field>
                                    </ValidationProvider>

                                    <ValidationProvider
                                        name="correo electrónico"
                                        rules="email|required"
                                        v-slot="{ errors }"
                                    >
                                        <v-text-field
                                            required
                                            filled
                                            rounded
                                            label="Correo electrónico"
                                            name="email"
                                            type="text"
                                            color="secondary"
                                            v-model="userData.email"
                                            :error-messages="errors"
                                        ></v-text-field>
                                    </ValidationProvider>

                                    <ValidationProvider
                                        name="contraseña"
                                        rules="required"
                                        v-slot="{ errors }"
                                    >
                                        <v-text-field
                                            required
                                            filled
                                            rounded
                                            label="Contraseña"
                                            name="password"
                                            prepend-inner-icon="mdi-lock"
                                            :append-icon="
                                                showPassword
                                                    ? 'mdi-eye-outline'
                                                    : 'mdi-eye-off-outline'
                                            "
                                            :type="
                                                showPassword
                                                    ? 'text'
                                                    : 'password'
                                            "
                                            color="secondary"
                                            v-model="userData.password"
                                            :error-messages="errors"
                                            @click:append="
                                                showPassword = !showPassword
                                            "
                                        ></v-text-field>
                                    </ValidationProvider>

                                    <v-btn
                                        rounded
                                        dark
                                        block
                                        x-large
                                        type="submit"
                                        class="btn-primary-shadow"
                                        color="primary"
                                        :loading="isLoading"
                                    >
                                        Registrarse
                                    </v-btn>
                                </v-form>
                            </ValidationObserver>
                        </div>
                    </v-expand-transition>
                </v-col>
            </v-row>
        </v-container>
    </section>
</template>

<script>
import { load } from "recaptcha-v3";

export default {
    name: "SignUp",

    data() {
        return {
            isLoading: false,
            signupWithEmail: false,
            showPassword: false,
            userData: {
                firstname: "",
                lastname: "",
                email: "",
                password: ""
            }
        };
    },

    methods: {
        // FUNCION CORRECTA (VERIFICACION DE DATOS)
        async signup() {
            try {
                this.isLoading = true;
                const recaptcha = await load(
                    "6Ldy7qsUAAAAAMtsyrpPNWJ8p6Z4YLVZ7jFIdPX0"
                );
                const token = await recaptcha.execute("login");
                // console.log(token);
                // alert('submit!');
                const res = await this.$store.dispatch("passport/SIGNUP", {
                    name: this.userData.firstname,
                    lastName: this.userData.lastname,
                    email: this.userData.email,
                    password: this.userData.password,
                    password_confirmation: this.userData.password
                });

                this.isLoading = false;
                this.$snotify.success("Se ha suscrito a PBXBerry.", "¡Genial!");
            } catch (error) {
                this.isLoading = false;
                this.$snotify.error(error.response.data.message, "¡Error!");
            }
        }
    }
};
</script>
